// extracted by mini-css-extract-plugin
export default {"container":"ko-z","ratingLayout":"lo-z","ratingLabel":"mo-z","nonInteractiveRatingLabel":"no-z"};